import type { StripeBillingConfig } from './stripeBillingService';

export type StripeConfigUiState =
  | { status: 'loading' }
  | { status: 'ready'; hasSecretKey: boolean; hasPublishableKey: boolean };

export function stripeConfigUiStateFromResult(
  result: Pick<StripeBillingConfig, 'hasSecretKey' | 'hasPublishableKey'> | 'error',
): StripeConfigUiState {
  if (result === 'error') {
    return { status: 'ready', hasSecretKey: false, hasPublishableKey: false };
  }
  return {
    status: 'ready',
    hasSecretKey: result.hasSecretKey,
    hasPublishableKey: result.hasPublishableKey,
  };
}

export function canAddStripeCard(state: StripeConfigUiState): boolean {
  return state.status === 'ready' && state.hasSecretKey && state.hasPublishableKey;
}

export function canManageStripeCards(state: StripeConfigUiState): boolean {
  return state.status === 'ready' && state.hasSecretKey;
}

export function createStripeConfigCache(load: () => Promise<StripeBillingConfig>): {
  get: () => Promise<StripeBillingConfig>;
  clear: () => void;
} {
  let inflight: Promise<StripeBillingConfig> | null = null;
  return {
    clear(): void {
      inflight = null;
    },
    get(): Promise<StripeBillingConfig> {
      if (!inflight) {
        inflight = load().catch((err: unknown) => {
          inflight = null;
          throw err;
        });
      }
      return inflight;
    },
  };
}
